import { lazy, ReactNode, Suspense } from 'react'
import { IWidget, WidgetConfig, WidgetDashboardConfig } from './widgetDashboard.interface'
import { WidgetTypes } from './widgetDashboard.enums'
import ChartWidget from './widgets/chartWidget/chartWidget'
import { getDefaultPane } from '../multiPane/multipPaneLayout.helper'
import { SuperChartConfiguration_TimeBucket } from '../../proto/generated/superchart-page'
import { Platform } from '../../proto/generated/user-preference'
import { TradeOptions } from '../../reducer/scalper.reducer'


export const getDefaultLayout = (): WidgetDashboardConfig => {
    return {
        panes: getDefaultPane(),
        singleMode: true,
        widgets: {},
        syncSettings: {
            security: false,
            crosshair: true,
            time: false,
            timeBucket: false,
            drawing: false
        }
    }
}
// Every layout has a candle chart, so that widget ships in the entry bundle. The others are
// only fetched when a layout actually contains them.
const OiWidget = lazy(() => import('./widgets/oiWidget/oiWidget'))
const OpenInterestChartWidget = lazy(() => import('./widgets/openInterestChartWidget/openInterestChartWidget'))
const MultiStrikeWidget = lazy(() => import('./widgets/multiStrikeWidget/multiStrikeWidget'))
const OptionChainWidget = lazy(() => import('./widgets/optionChainWidget/optionChainWidget'))

export const getWidgetComponent = (dashboardId: string, {
    widgetType,
    settings,
    slotId
}: WidgetConfig<any>, ref: Record<string, IWidget>, hoveredPane: number, allowSplit?: boolean, tradeOptions?: TradeOptions): ReactNode => {
    switch (widgetType) {
        case WidgetTypes.OI_CHART:
            return <Suspense fallback={null}><OiWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} /></Suspense>
        case WidgetTypes.OPEN_INTEREST_CHART:
            return <Suspense fallback={null}><OpenInterestChartWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} /></Suspense>
        case WidgetTypes.MULTI_STRIKE_CHART:
            return <Suspense fallback={null}><MultiStrikeWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} /></Suspense>
        case WidgetTypes.OPTION_CHAIN:
            return <Suspense fallback={null}><OptionChainWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} /></Suspense>
        case WidgetTypes.CHART:
        case WidgetTypes.FUTURE_CHART:
        case WidgetTypes.ATM_OPTION_CHART:
        case WidgetTypes.OPTION_CHART:
            return <ChartWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} />
    }
}

export const getDefaultWidget = (dashboardId: string, slotId: number, widgetType: WidgetTypes, key: string, expressionMode: boolean, securities: string[], timeBucket?: SuperChartConfiguration_TimeBucket): WidgetConfig<any> => {
    switch (widgetType) {
        case WidgetTypes.CHART:
        default:
            return {
                slotId,
                widgetType,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key,
                    securities,
                    expressionMode,
                    timeBucket
                }
            }
    }
}

export const getDashboardSlotIdFromKey = (key: string): [string, string] => {
    const [dashboardId, slotId] = key.split('-')
    return [dashboardId, slotId]
}

export const normalizePlatform = (p: Platform) => {
    switch (p) {
        case Platform.MOBILE:
        case Platform.DESKTOP:
            return p;
        default:
            return Platform.DESKTOP;
    }
}